import(/* webpackMode: "eager" */ "/vercel/path0/components/stories.module.css");
import(/* webpackMode: "eager" */ "/vercel/path0/components/story.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.0.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/link.js")